/*
 * Venn Platform API 1.0.0 Operations for "compliance"
 * Automatically generated file - do not modify!
 */

import type { AggregateUserAgreement, ComplianceExportQuery, ComplianceExportRow } from '../types';
import type { OperationResult } from '../../utils';
import { buildQuery, buildRequestInit, extractError, retryGeneratedFetch } from '../../utils';

/** Retrieve aggregate agreements */
export async function aggregateAgreement(
  all?: boolean,
  signal?: AbortSignal,
): Promise<OperationResult<AggregateUserAgreement[]>> {
  const endpoint = `/api/compliance/agreement/aggregate${buildQuery({ all })}`;
  const requestInit = buildRequestInit({ method: 'GET', signal });
  const response = await retryGeneratedFetch('GET', () => fetch(endpoint, requestInit));
  if (response.status >= 200 && response.status < 400) {
    const content: AggregateUserAgreement[] = (await response.json()) as AggregateUserAgreement[];
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
/** Search compliance export metadata by date range */
export async function searchMetadata(
  body?: Partial<ComplianceExportQuery>,
  signal?: AbortSignal,
): Promise<OperationResult<ComplianceExportRow[]>> {
  const endpoint = '/api/compliance-export/metadata';
  const requestInit = buildRequestInit({
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
    signal,
  });
  const response = await retryGeneratedFetch('POST', () => fetch(endpoint, requestInit));
  if (response.status >= 200 && response.status < 400) {
    const content: ComplianceExportRow[] = (await response.json()) as ComplianceExportRow[];
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
